export default __webpack_public_path__ + "static/media/81.97917c0c.jpg";